<ion-list>
    <div *ngIf="!amo?.wanh && !amo?.ashley && !amo?.kelli && amo?.advisor">
        <ion-item>
            <ion-label>
                <p>
                    <a
                        href="tel: {{
                            (toolService.content | async)?.basic?.phone?.main
                        }}"
                        >{{
                            (toolService.content | async)?.basic?.phone?.main
                        }}</a
                    >
                </p>
            </ion-label>
        </ion-item>
        <ion-item lines="none">
            <ion-label>
                <p>
                    <span>
                        <a
                            href="mailto:{{
                                (toolService.content | async)?.basic?.email
                                    ?.advisors
                            }}"
                            class="link-anchor"
                            >{{
                                (toolService.content | async)?.basic?.email
                                    ?.advisors
                            }}</a
                        >
                    </span>
                </p>
            </ion-label>
        </ion-item>
    </div>
    <div *ngIf="amo?.unassignedcoach">
        <ion-item lines="none">
            <ion-label>
                <p>
                    <span>
                        <a
                            href="mailto:{{
                                (toolService.content | async)?.basic?.email
                                    ?.success
                            }}"
                            class="link-anchor"
                            >{{
                                (toolService.content | async)?.basic?.email
                                    ?.success
                            }}</a
                        >
                    </span>
                </p>
            </ion-label>
        </ion-item>
    </div>
    <div *ngIf="amo?.wanh">
        <ion-item lines="none">
            <ion-label>
                <p>
                    <span>
                        <a
                            href="mailto:{{
                                (toolService.content | async)?.basic?.email
                                    ?.coachWanh
                            }}"
                            class="link-anchor"
                            >{{
                                (toolService.content | async)?.basic?.email
                                    ?.coachWanh
                            }}</a
                        >
                    </span>
                </p>
            </ion-label>
        </ion-item>
    </div>
    <div *ngIf="amo?.kelli">
        <ion-item lines="none">
            <ion-label>
                <p>
                    <span>
                        <a
                            href="mailto:{{
                                (toolService.content | async)?.basic?.email
                                    ?.coachKelli
                            }}"
                            class="link-anchor"
                            >{{
                                (toolService.content | async)?.basic?.email
                                    ?.coachKelli
                            }}</a
                        >
                    </span>
                </p>
            </ion-label>
        </ion-item>
    </div>
    <div *ngIf="amo?.ashley">
        <ion-item lines="none">
            <ion-label>
                <p>
                    <span>
                        <a
                            href="mailto:{{
                                (toolService.content | async)?.basic?.email
                                    ?.coachAshley
                            }}"
                            class="link-anchor"
                            >{{
                                (toolService.content | async)?.basic?.email
                                    ?.coachAshley
                            }}</a
                        >
                    </span>
                </p>
            </ion-label>
        </ion-item>
    </div>
    <div *ngIf="amo?.justin">
        <ion-item lines="none">
            <ion-label>
                <p>
                    <span>
                        <a
                            href="mailto:{{
                                (toolService.content | async)?.basic?.email
                                    ?.coachJustin
                            }}"
                            class="link-anchor"
                            >{{
                                (toolService.content | async)?.basic?.email
                                    ?.coachJustin
                            }}</a
                        >
                    </span>
                </p>
            </ion-label>
        </ion-item>
    </div>
    <div *ngIf="amo?.chris">
        <ion-item lines="none">
            <ion-label>
                <p>
                    <span>
                        <a
                            href="mailto:{{
                                (toolService.content | async)?.basic?.email
                                    ?.coachChris
                            }}"
                            class="link-anchor"
                            >{{
                                (toolService.content | async)?.basic?.email
                                    ?.coachChris
                            }}</a
                        >
                    </span>
                </p>
            </ion-label>
        </ion-item>
    </div>


    <div *ngIf="amo?.grace">
        <ion-item lines="none">
            <ion-label>
                <p>
                    <span>
                        <a
                            href="mailto:{{
                                (toolService.content | async)?.basic?.email
                                    ?.coachGrace
                            }}"
                            class="link-anchor"
                            >{{
                                (toolService.content | async)?.basic?.email
                                    ?.coachGrace
                            }}</a
                        >
                    </span>
                </p>
            </ion-label>
        </ion-item>
    </div>


    <div *ngIf="amo?.caleb">
        <ion-item lines="none">
            <ion-label>
                <p>
                    <span>
                        <a
                            href="mailto:{{
                                (toolService.content | async)?.basic?.email
                                    ?.coachCaleb
                            }}"
                            class="link-anchor"
                            >{{
                                (toolService.content | async)?.basic?.email
                                    ?.coachCaleb
                            }}</a
                        >
                    </span>
                </p>
            </ion-label>
        </ion-item>
    </div>
</ion-list>